<app-displaybar buttonTitle="Join Now" text="Nursing The Way It Should Be."></app-displaybar>
<app-bulletcard [card]="bullet" ></app-bulletcard>
<ng-container *ngFor="let card of cards">
  <app-centercard [card]="card"></app-centercard>
</ng-container>
<app-centercard [card]="{title: 'Our Team', color: '--second'}" ></app-centercard>
<ng-container *ngFor="let profile of profiles">
  <app-profilecard [card]="profile" ></app-profilecard>
</ng-container>
